import i18next from 'i18next';
import * as yup from 'yup';

yup.setLocale({
  string: {
    max: ({ max }) => i18next.t('yup-validation-string-max', { max }),
  },
});
